
import useGetQueryPagination from "./helper/ueGetPagination";

const API = {
    GET_ALL: `home`,
};
const KEY = "home"


export const useGetHome = (params?:any) => useGetQueryPagination(KEY, API.GET_ALL,params);
